export default __webpack_public_path__ + "static/media/univision.20ba0625.svg";